import { render, staticRenderFns } from "./testIndex.vue?vue&type=template&id=10d95524&scoped=true&"
import script from "./testIndex.vue?vue&type=script&lang=js&"
export * from "./testIndex.vue?vue&type=script&lang=js&"
import style0 from "./testIndex.vue?vue&type=style&index=0&id=10d95524&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d95524",
  null
  
)

component.options.__file = "testIndex.vue"
export default component.exports